import { ActionService } from 'dashboard-services/services';

export default (() => {

  const CHANGE_VALUE = 'CHANGE_VALUE_PDF_VIEWER'
  const changeValue = ActionService.makeActionCreator(CHANGE_VALUE, 'value', 'name')

  return {
    changeValue,
    CHANGE_VALUE
  }
})()